import { gql } from '@apollo/client';

export default class GeneralMutation {
    static UPLOAD_COMMON_RESOURCE = gql`
        mutation uploadCommonResource(
            $module: String!,
            $section: String!,
            $bucket: String!,
            $resourceName: String!,
            $file: Upload!
        ) {
            uploadCommonResource(
                module: $module,
                section: $section,
                bucket: $bucket,
                resourceName: $resourceName,
                file: $file
            )
        }
    `;

    static DELETE_COMMON_RESOURCE = gql`
        mutation deleteCommonResource(
            $commonResourceId: ID!
        ) {
            deleteCommonResource(
                commonResourceId: $commonResourceId
            )
        }
    `;

    static ADD_TRAINING_CATEGORY = gql`
        mutation addTrainingCategory(
            $name: String!,
            $order: Int!
        ) {
            addTrainingCategory(
                name: $name,
                order: $order
            )
        }
    `;

    static EDIT_TRAINING_CATEGORY = gql`
        mutation editTrainingCategory(
            $trainingCategoryId: ID!,
            $name: String!,
            $active: Boolean!
        ) {
            editTrainingCategory(
                trainingCategoryId: $trainingCategoryId,
                name: $name,
                active: $active
            )
        }
    `;

    static ADD_TRAINING_ELEMENT = gql`
        mutation addTrainingElement(
            $trainingCategoryId: ID!,
            $name: String!,
            $description: String,
            $type: String!,
            $url: String!,
            $matchingRoute: String,
            $order: Int!
        ) {
            addTrainingElement(
                trainingCategoryId: $trainingCategoryId,
                name: $name,
                description: $description,
                type: $type,
                url: $url,
                matchingRoute: $matchingRoute,
                order: $order
            )
        }
    `;

    static EDIT_TRAINING_ELEMENT = gql`
        mutation editTrainingElement(
            $trainingElementId: ID!,
            $trainingCategoryId: ID!,
            $name: String!,
            $description: String,
            $type: String!,
            $url: String!,
            $matchingRoute: String,
            $active: Boolean!
        ) {
            editTrainingElement(
                trainingElementId: $trainingElementId,
                trainingCategoryId: $trainingCategoryId,
                name: $name,
                description: $description,
                type: $type,
                url: $url,
                matchingRoute: $matchingRoute,
                active: $active
            )
        }
    `;

    static SET_TRAINING_CATEGORIES_ORDER = gql`
        mutation setTrainingCategoriesOrder(
            $input: [TrainingCategoryOrder!]!
        ) {
            setTrainingCategoriesOrder(
                input: $input
            )
        }
    `;

    static SET_TRAINING_ELEMENTS_ORDER = gql`
        mutation setTrainingElementsOrder(
            $input: [TrainingElementOrder!]!
        ) {
            setTrainingElementsOrder(
                input: $input
            )
        }
    `;

    static DOWNLOAD_IMAGES = gql`
        mutation downloadImages($images: [ImageDownloadInput!]!) {
            downloadImages(images: $images) {
                url
                base64
                mimeType
                fileName
                success
                error
            }
        }
    `;
}
